export const DEPARTMENT_VIEW_SET = 'DEPARTMENT_VIEW_SET';
export const CHAIN_DEPARTMENT_VIEW_SET = 'CHAIN_DEPARTMENT_VIEW_SET';
export const DEPARTMENT_PREV_PAGE = 'DEPARTMENT_PREV_PAGE';
export const CHAIN_DEPARTMENT_PREV_VIEW_SET = 'CHAIN_DEPARTMENT_PREV_VIEW_SET';
